import React from 'react';

import ScrollMoreArrow from '@/assets/seasonal-guides/winter/arrow.svg';
import HeroBadgeAnimated from '@/assets/seasonal-guides/winter/hero-badge-animated.svg';
import HeroBadgeStatic from '@/assets/seasonal-guides/winter/hero-badge-static.svg';

import { SeasonalGuideHero } from './SeasonalGuideHero';
import { SeasonalGuideSections } from './SeasonalGuideSections';
import { TSeasonalGuideSection } from './types';

const heroMediaFallbackUrl = '/assets/seasonal-guides/winter/hero-media-fallback.png';
const heroMediaHighBitrateUrl = '/assets/seasonal-guides/winter/hero-media-high-bitrate.mp4';
const heroMediaMedBitrateUrl = '/assets/seasonal-guides/winter/hero-media-med-bitrate.mp4';

type TWinterGuidesTemplateProps = {
  sections: TSeasonalGuideSection[];
};

export const WinterGuidesTemplate = ({ sections }: TWinterGuidesTemplateProps) => {
  return (
    <>
      <SeasonalGuideHero
        heroMediaMedBitrateUrl={heroMediaMedBitrateUrl}
        heroMediaHighBitrateUrl={heroMediaHighBitrateUrl}
        heroMediaFallbackUrl={heroMediaFallbackUrl}
        heroMediaFallbackBlurImage="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAIBAMAAADU/bjBAAAAIVBMVEVRWGA+RExCSVJOVF1cYmhLUVpHTlhXXWQ4PUQyNjwpLDDAc60WAAAATklEQVQI12MQDjZ3YGFIVGBYqBDiaMKcmsAwIyGEMdyh1YDBqDxESbm80YBBiMVYKMW9U4ChMSFJOKREqoFhEnOkaIJAFoihlSSgmjUBAGGZEbxjRuPPAAAAAElFTkSuQmCC"
        HeroBadgeAnimated={HeroBadgeAnimated}
        HeroBadgeStatic={HeroBadgeStatic}
        header="Create magical moments this winter"
        description="Can we coax you out of hibernation with snowmen, hot cocoa, ski trips, and an RV equipped with a heater?"
        footerText="GET STOKED FOR SNOW"
        scrollMoreArrow={<ScrollMoreArrow />}
      />
      <SeasonalGuideSections sections={sections} />
    </>
  );
};
